import React, { useEffect, useState } from 'react';
import { CardForm } from '../../shared/components/card-form/card-form';
import { PAYMENT_METHOD } from '../../shared/constants';

// Hooks
import usePaymentStore from '../../shared/store/use-payment-store';
import { useKushki } from '../hooks/use-kushki';

// Utils
import API, { socketPurchases } from '../../../../utils/api';
import { showModalError } from '../../shared/components/modals/modal-error';
import { showModalSuccessPayment } from '../../shared/components/modals/modal-success';
import gaUtils from '../../../../components/GAWrapper/GAWrapper';
import { waitVerificationName } from '../../shared/components/modals/modal-verification-name';
import { waitUserCancelCashoutsPending } from '../../shared/utils/cashouts';

// Assets
import kushkiLogo from '../assets/logo-kushki.svg';

const IN_TEST_ENVIRONMENT = process.env.REACT_APP_KUSHKI_IN_TEST_ENVIRONMENT;

export const CardKushki = ({ setSelectedMethod, ...props }) => {
  const { amount } = usePaymentStore();
  const kushki = useKushki();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    socketPurchases.on('purchase:completed', data => {
      const transaction = {
        amount: data.amount,
        provider: 'Kushki',
        transactionId: data?.trans_id,
      };

      API.trackPurchaseSuccessFB(transaction);
      gaUtils.trackUserPurchase(transaction);

      showModalSuccessPayment({
        amount: data.amount,
        balance: data.balance,
        trans_id: data.trans_id,
      });

      setSelectedMethod(PAYMENT_METHOD.WELCOME);

      if (props.dispatch) {
        props.updateUserInfo(props.dispatch);
      } else if (props.updateUserBalance) {
        props.updateUserBalance(data.balance);
      }
    });

    return () => {
      socketPurchases.off('purchase:completed');
      socketPurchases.off('purchase:failed');
    };
  }, []);

  const doPurchaseWithToken = async (token, card) => {
    try {

      const name = card.name;
      const nameCheckResponse = await API.checkName(name);

      if (!nameCheckResponse.data.success) {
        showModalError({ errorMessage: nameCheckResponse.data?.message ?? 'Ha ocurrido un error' });
        setIsSubmitting(false);
        return;
      }

      const response = await API.processCardPaymentKushki({
        token,
        amount
      });

      if (response.data.success) {
        setIsSubmitting(false);
      } else {
        setIsSubmitting(false);
        const errorMessage = response.data?.error || response.data?.message || 'Ha ocurrido un error';
        const errorCode = response.data?.code || '';
        showModalError({ errorMessage, errorCode });
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error('Error processing payment:', error);
      const errorMessage = error?.response?.data?.error || error?.message || 'Ha ocurrido un error';
      const errorCode = error?.response?.data?.code || '';
      showModalError({ errorMessage, errorCode });
    }
  };

  const handleSubmit = async (cardData) => {
    if (!kushki) {
      console.error('Kushki no está inicializado');
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);

    // const isVerified = await waitVerificationName({
    //   title: 'Verificación de nombre',
    // });

    // if (!isVerified) {
    //   alert('Por favor, verifica tu cuenta para continuar.');
    //   setIsSubmitting(false);
    //   return;
    // }

    const userCancell = await waitUserCancelCashoutsPending(); 

    if (userCancell) {
      setIsSubmitting(false);
      return;
    }

    const card = {
      name: cardData.holderName,
      number: cardData.cardNumber,
      cvc: cardData.cvv,
      expiryMonth: cardData.expirationMonth,
      expiryYear: cardData.expirationYear,
    };

    kushki.requestToken({
      amount: Number(amount),
      currency: 'MXN',
      card,
    }, (response) => {
      if (response?.error) {
        setIsSubmitting(false);
        const { code, message } = response;
        showModalError({
          errorCode: code,
          errorMessage: message || `Error ${code || ''}`.trim() || 'Ha ocurrido un error'
        });
      } else {
        const { token, secureId, security } = response;

        if (security?.authRequired === true) {
          kushki.requestValidate3DS({
            secureId: secureId,
            security: {
              acsURL: security.acsURL,
              authenticationTransactionId: security.authenticationTransactionId,
              paReq: IN_TEST_ENVIRONMENT === 'true' ? 'sandbox' : security.paReq,
              specificationVersion: security.specificationVersion,
              authRequired: true,
            },
          }, function (response) {
            if (response?.isValid === true) {
              doPurchaseWithToken(token, card);
            } else {
              setIsSubmitting(false);
              const { code, message } = response;
              showModalError({
                errorCode: code,
                errorMessage: message || `Error ${code || ''}`.trim() || 'Ha ocurrido un error'
              });
            }
          });
        } else {
          doPurchaseWithToken(token, card);
        }
      }
    });
  };

  const handleNavigateToOtherCard = () => {
    if (setSelectedMethod) {
      setSelectedMethod(PAYMENT_METHOD.OTHER_CARD);
    }
  };

  return (
    <div>
      <CardForm
        showSaveCard={false}
        onSubmit={handleSubmit}
        onNavigateToOtherCard={handleNavigateToOtherCard}
        isSubmitting={isSubmitting}
        logoBrand={kushkiLogo}
      />
    </div>
  );
};